module.exports = __webpack_public_path__ + "img/4-5.0aabe1c0.png";